module.exports = __webpack_public_path__ + "static/media/ModelMolecules.66b5b7af.logo";